module.exports = __webpack_public_path__ + "static/media/machine.5f866fce.png";